class Util {
  constructor() {}

  //Validar se um email é válido
  validarEmail(email) {
    // eslint-disable-next-line
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  // validar CPF ou CNPJ
  validarCPFCNPJ(cpfCnpj) {
    if (!cpfCnpj) return false;

    // Limpa a máscara: remove o que não for letra ou número e converte para maiúsculo
    cpfCnpj = cpfCnpj.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

    if (cpfCnpj.length === 0) return false;

    // Trava de segurança: se conter letras, o tamanho OBRIGATORIAMENTE deve ser 14 (CNPJ)
    if (/[A-Z]/.test(cpfCnpj) && cpfCnpj.length < 14) {
      return false;
    }

    let validado = false;

    if (cpfCnpj.length === 14) {
      validado = this.validarCNPJ(cpfCnpj);
    } else if (cpfCnpj.length === 11) {
      validado = this.validarCPF(cpfCnpj);
    }

    return validado;
  }

  // Validação de CNPJ (Suporta Alfanumérico)
  validarCNPJ(cnpj) {
    if (!cnpj || cnpj.length !== 14) return false;

    // Elimina CNPJs invalidos conhecidos (Ex: 00000000000000, AAAAAAAAAAAAAA)
    if (/^(\w)\1{13}$/.test(cnpj)) {
      return false;
    }

    let baseCnpj = cnpj.substring(0, 12);
    let dv1Digitado = parseInt(cnpj.charAt(12));
    let dv2Digitado = parseInt(cnpj.charAt(13));

    // Função interna para o cálculo do Módulo 11 com regra da Tabela ASCII
    const calcularDV = (cnpjParcial, pesos) => {
      let soma = 0;
      for (let i = 0; i < cnpjParcial.length; i++) {
        // Regra do Serpro: Atribuir valor ASCII do caractere e subtrair 48
        let valor = cnpjParcial.charCodeAt(i) - 48;
        soma += valor * pesos[i];
      }
      let resto = soma % 11;
      return resto < 2 ? 0 : 11 - resto;
    };

    // Valida o 1º DV
    let pesosDV1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let dv1Calculado = calcularDV(baseCnpj, pesosDV1);
    if (dv1Calculado !== dv1Digitado) return false;

    // Valida o 2º DV
    let pesosDV2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let dv2Calculado = calcularDV(baseCnpj + dv1Calculado, pesosDV2);
    if (dv2Calculado !== dv2Digitado) return false;

    return true;
  }

  // Validar CPF
  validarCPF(strCPF) {
    if (!strCPF) return false;
    let Soma = 0;
    let Resto;

    if (strCPF === '00000000000') return false;

    for (let i = 1; i <= 9; i++) {
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    }
    Resto = (Soma * 10) % 11;

    if (Resto === 10 || Resto === 11) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

    Soma = 0;
    for (let i = 1; i <= 10; i++) {
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    }
    Resto = (Soma * 10) % 11;

    if (Resto === 10 || Resto === 11) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(10, 11))) return false;

    return true;
  }

  removerEspacos(texto) {
    if (typeof texto !== 'string') {
      return texto;
    }
    return texto.replace(/\s/g, '');
  }

  /**
   * Converte uma string de data (yyyy-MM-dd) para um objeto Date do JavaScript.
   */
  stringToDate(dateString) {
    if (!dateString) return null;

    if (dateString instanceof Date) return dateString;

    const [y, m, d] = dateString.split('-');
    return new Date(Number(y), Number(m) - 1, Number(d));
  }

  /**
   * Converte um objeto Date do JavaScript para uma string no formato LocalDate (yyyy-MM-dd).
   */
  dateToString(date) {
    if (!date) return null;

    if (typeof date === 'string') return date;

    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');

    return `${y}-${m}-${d}`;
  }
}

export default new Util();
